import { MessageWithClippedTitle } from "@/utils/product/getPromoMessaging.ts";
import { basketItemWithPromotions } from "@/utils/product/getBasketData";
import { PromotionalMessage } from "@/types/prodcatBaseTypes";
import { MessageWithCategoryAndType } from "@/utils/product/getPromoMessaging";

export type TargetProduct = {
  productId: string;
  promoMessage: MessageWithCategoryAndType;
};

export type SpendStretchProduct = {
  promoMessage: MessageWithCategoryAndType;
  targetProductId?: string;
  spendStretchTotal: number | null;
};

export type CurrentProduct = {
  productId: string;
  promoMessage: MessageWithCategoryAndType;
  qualifyingProductQuantity: number;
};

export const getSpendStretchQualifyingBasketItemsTotal = (
  currentPromotionMessage: MessageWithClippedTitle,
  basketProducts: basketItemWithPromotions[],
  targetProductId?: string,
) => {
  return basketProducts.reduce(
    (acc: number, basketProduct: basketItemWithPromotions) => {
      const hasSamePromotion = basketProduct.detailedPromotionalMessages.some(
        (message: PromotionalMessage) =>
          message.title === currentPromotionMessage.title,
      );
      const isIncludedInPromotion = basketProduct.productId !== targetProductId;

      if (hasSamePromotion && isIncludedInPromotion) {
        acc += +(basketProduct.price * basketProduct.quantity).toFixed(2);
      }

      return acc;
    },
    0,
  );
};

export const getFirstPromptQualifyingBasketItem = (
  basketProducts: Array<basketItemWithPromotions>,
  qualifyingProducts: Array<TargetProduct>,
): TargetProduct | undefined => {
  if (basketProducts.length === 0 || qualifyingProducts.length === 0)
    return undefined;
  let returnedQualifyingProduct: TargetProduct | undefined;
  basketProducts.find(
    (basketProduct) =>
      (returnedQualifyingProduct = qualifyingProducts.find(
        (qualifyingProduct) =>
          qualifyingProduct.productId === basketProduct.productId,
      )),
  );
  return returnedQualifyingProduct;
};

export const hasPromptQualifyingBasketItemQuantity = (
  basketProducts: Array<basketItemWithPromotions>,
  qualifyingProduct: CurrentProduct | undefined,
): boolean => {
  if (basketProducts.length === 0 || !qualifyingProduct) return false;
  const totalQuantity = basketProducts
    .filter(
      (basketProduct) =>
        basketProduct.productId === qualifyingProduct.productId,
    )
    .reduce((sum, basketProduct) => sum + basketProduct.quantity, 0);

  return totalQuantity >= qualifyingProduct.qualifyingProductQuantity;
};
